<div *ngFor="let product of productList">
  <app-product [product]="product"></app-product>
</div>